module.exports = __webpack_public_path__ + "static/media/logo_ternate.79fa49b1.png";